class AuthService{
    /*@ngInject*/
    constructor($state,UserService,$q, SocketService){
        this.$state = $state;
        this.userService = UserService;
        this.$q = $q;
        this.socket = SocketService;
    }
    requireAuth(){
        this.userService.loadUserFromSession();
        if(!this.userService.isValid() || this.userService.getUser().name ===null || !this.socket.isAuthenticated()){
            return this.$q.reject({code:'AUTH_REQUIRED'});
        }
        return this.userService.getUser();
    }

}

export default AuthService;


// WEBPACK FOOTER //
// ./public/app/services/auth.service.js